export default "__VITE_ASSET__umFOaYQt__"